import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReportResponse } from 'app/report/models/report-response.model';
import { ReportService } from 'app/report/services/report.service';
import { RoutingService } from '../../../../routing/services/routing.service';

@Component({
  selector: 'app-report-list-item',
  templateUrl: './simple-report-list-item.component.html',
  styleUrls: ['../../../scss/dashboard.components.scss', '../../../../report/scss/report-common.scss']
})
export class SimpleReportListItemComponent {

  @Input() project: ReportResponse;

  constructor(private reportService: ReportService, private routingService: RoutingService) {
  }

  onReportEdit() {
  }

  enableViewSummary = () => { return this.project.report.reportStatusId === 1; }

  viewSummary() {
    if (this.enableViewSummary())
      this.routingService.routeToReportSummary(this.project.report.id);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/components/recent-reports/item/simple-report-list-item.component.ts